<template>
  <div class="projects">
    <h1 class="subheading grey--text mb-3 hidden-sm-and-up">
      {{ $t('common.Dashboard') }}
    </h1>
    <v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs12 md6 v-for="card in cards" :key="card.title">
          <v-card
            @click="card.route ? null : (showDialog = true)"
            :to="card.route || null"
            class="ma-2 pointer card-rounded"
            flat
          >
            <div class="pa-2 dashboard-card__content">
              <v-card-title class="pr-0">
                <v-avatar size="46px" class="mr-3">
                  <Icon size="46px" :name="card.icon" />
                </v-avatar>
                <div>
                  <h2 class="grey--text text--darken-2" v-text="card.title" />
                  <span v-text="card.text" />
                </div>
              </v-card-title>
            </div>
            <v-chip
              v-if="card.chip"
              class="dashboard-card__chip"
              color="primary"
              small
              text-color="white"
            >
              <v-avatar class="green darken-4">{{ card.chip.avatar }}</v-avatar>
              {{ card.chip.text }}
            </v-chip>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-container v-if="userIsOphthalmology">
      <ophthalmology-dashboard />
    </v-container>
  </div>
</template>

<script>
import OphthalmologyDashboard from '@/components/dashboards/OphthalmologyDashboard'
import { mapGetters } from 'vuex'
import Icon from '@/components/icons/Icons.vue'
import { getClinicalLogCount } from '../services/mongodb'

export default {
  components: {
    OphthalmologyDashboard,
    Icon
  },
  data() {
    return {
      items: [
        {
          src: '/conference.jpg',
          caption: 'Conference, Paris'
        },
        {
          src: '/surgery.jpg',
          caption: 'Simulation practise'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['user']),
    logCount() {
      return this.$store.state.logs.logCount
    },
    userIsORL() {
      return this.user.specialty === 'orl'
    },
    userIsOphthalmology() {
      return this.user.specialty === 'ophthalmology'
    },
    userIsNationalAdmin() {
      return this.user && (this.user.roles || []).includes('national-admin')
    },
    cards() {
      return [
        {
          title: this.getSpecialtyLabel(),
          text: `Gerir logbook`,
          chip: this.logCount
            ? { text: 'Total', avatar: `${this.logCount}` }
            : null,
          color: 'primary',
          icon: 'clipboard',
          route: { name: 'Logbook', params: { openDialog: true } }
        },
        {
          title: 'Act. Científica',
          text: 'Publicações e comunicações',
          color: 'secondary',
          icon: 'cientific',
          route: { name: 'Curriculum', query: { openDialog: true } }
        },
        {
          title: 'Act. Formativas',
          text: 'Cursos e congressos',
          color: 'warning',
          icon: 'certific',
          route: { name: 'Course', query: { openDialog: true } }
        },
        {
          title: 'Estágios',
          text: 'Criar Novo Estágio',
          color: 'secondary',
          icon: 'internship',
          route: { name: 'Internships', query: { openDialog: true } }
        }
      ]
    }
  },
  methods: {
    getSpecialtyLabel() {
      const specialtyLabels = {
        anesthesiology: 'Anestesiologia',
        'general-surgery': 'Cirurgia Geral',
        'family-medicine': 'Medicina Geral e Familiar',
        orthopedics: 'Ortopedia'
      }
      return (
        specialtyLabels[this.$store.getters.specialty] ||
        this.$t('common.Logbook')
      )
    }
  },
  async created() {
    if (!this.$store.state.logCount) {
      this.$store.dispatch('fetchLogCount')
    }
  }
}
</script>

<style scoped>
.dashboard-card__chip {
  position: absolute;
  bottom: 2px;
  right: 2px;
}

.dashboard-card__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}
</style>
